"use client"

import { Analytics as VercelAnalytics } from "@vercel/analytics/react"

export function Analytics() {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return null;
  }

  return <VercelAnalytics />
}
